import axiosClient from "./axiosClient";

export const selectionHistoryApi = {
  getUserSelectionHistories: (userId: number) => {
    const url = `api/user-selection-histories/${userId}`;
    return axiosClient.get(url);
  },
  getGroupSelectionHistories: (userId: number) => {
    const url = `api/group-selection-histories/${userId}`;
    return axiosClient.get(url);
  },
  getConstructionSelectionHistories: (userId: number) => {
    const url = `api/construction-selection-histories/${userId}`;
    return axiosClient.get(url);
  },
  getTimesheetSelectionHistories: (userId: number) => {
    const url = `api/timesheet-selection-histories/${userId}`;
    return axiosClient.get(url);
  },
  getOvertimeSelectionHistories: (userId: number) => {
    const url = `api/overtime-selection-histories/${userId}`;
    return axiosClient.get(url);
  },
  getScheduleRoomSelectionHistories: (userId: number) => {
    const url = `api/scheduleroom-selection-histories/${userId}`;
    return axiosClient.get(url);
  },
  getDefaultParticipantsSelectionHistories: (userId: number) => {
    const url = `api/default-participants-selection-histories/${userId}`;
    return axiosClient.get(url);
  },

  // POST
  storeUserSelectionHistory: (body: any) => {
    const url = `api/user-selection-histories`;
    return axiosClient.post(url, body);
  },
  storeGroupSelectionHistory: (body: any) => {
    const url = `api/group-selection-histories`;
    return axiosClient.post(url, body);
  },
  storeConstructionSelectionHistory: (body: any) => {
    const url = `api/construction-selection-histories`;
    return axiosClient.post(url, body);
  },
  storeTimesheetSelectionHistory: (body: any) => {
    const url = `api/timesheet-selection-histories`;
    return axiosClient.post(url, body);
  },
  storeOvertimeSelectionHistory: (body: any) => {
    const url = `api/overtime-selection-histories`;
    return axiosClient.post(url, body);
  },
  storeScheduleRoomSelectionHistory: (body: any) => {
    const url = `api/scheduleroom-selection-histories`;
    return axiosClient.post(url, body);
  },
  storeDefaultParticipantsSelection: (body: any) => {
    const url = `api/default-participants-selection-histories`;
    return axiosClient.post(url, body);
  }, 
};
